/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { faFile, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useEffect, useMemo, useRef } from "react";
import { ChatProperties, IUser } from "../../types";

interface IMessageProps {
  message: any;
  user?: IUser;
  chat: ChatProperties;
}

const Message: React.FC<IMessageProps> = ({ message, user, chat }) => {
  const messageRef = useRef<HTMLPreElement>(null);

  useEffect(() => {
    const url = new RegExp(
      /(\b(https?|ftp):\/\/[A-Z0-9+&@#/%?=~_|!:,.;-]*[-A-Z0-9+&@#/%=~_|])/gim,
    );

    if (messageRef) {
      if (messageRef.current) {
        messageRef.current.innerHTML = messageRef.current.innerHTML.replace(
          url,
          '<a href="$1" target="_blank">$1</a>',
        );
      }
    }
  }, [messageRef]);

  const messageCreatedDate = useMemo(() => {
    return moment(message.createdAt).format("DD/MM/YYYY");
  }, [message]);

  const messageCreatedHour = useMemo(() => {
    return moment(message.createdAt).format("HH:mm");
  }, [message]);

  const isAuthor = useMemo(
    () => message.author_email === user?.email,
    [message, user],
  );

  const fileIsImage = useMemo(
    () =>
      message.file &&
      (message.file.includes(".png") ||
        message.file.includes(".jpg") ||
        message.file.includes(".jpe") ||
        message.file.includes(".jpeg")),
    [message],
  );

  return (
    <>
      {message.firstMessage && chat.open && chat.responsible_uuid === null && (
        <li
          style={{
            backgroundColor: "transparent",
            width: "100%",
            maxWidth: "100%",
            marginBottom: "0px",
            opacity: 1,
          }}
        >
          <div className="clerk">
            <span>{message.firstMessage}</span>
          </div>
        </li>
      )}
      {message.uuid && (
        <li
          style={{
            backgroundColor: "transparent",
            width: "100%",
            maxWidth: "100%",
            opacity: 1,
          }}
        >
          <div className="clerk">
            <span>
              <b>{message.name}</b> se conectou ao chat
            </span>
          </div>
        </li>
      )}
      {message.text?.length === 0 ||
      message.firstMessage ||
      message.uuid ? null : (
        <li className={isAuthor ? "author" : ""}>
          <pre ref={messageRef}>{message.text}</pre>
          <span className="hour">{messageCreatedHour}</span>
          <span className="date">{messageCreatedDate} -</span>
        </li>
      )}
      {!message.file || message.firstMessage || message.uuid ? null : (
        <li className={isAuthor ? "author" : ""}>
          <div
            className="div_file"
            onClick={() => {
              window.open(message.file, "_blank");
            }}
          >
            <span>
              {fileIsImage ? (
                <img
                  src={message.file}
                  alt={message.file}
                  style={{
                    maxHeight: "120px",
                  }}
                />
              ) : (
                <FontAwesomeIcon
                  icon={message.file.includes(".pdf") ? faFilePdf : faFile}
                />
              )}
            </span>
            <p>{message.file.split("uploads/")[1]}</p>
          </div>
        </li>
      )}
    </>
  );
};

export default Message;
